import { render, staticRenderFns } from "./PleurisyEconomicLossReport.vue?vue&type=template&id=79acc1c8&scoped=true&"
import script from "./PleurisyEconomicLossReport.vue?vue&type=script&lang=ts&"
export * from "./PleurisyEconomicLossReport.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyEconomicLossReport.vue?vue&type=style&index=0&id=79acc1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79acc1c8",
  null
  
)

export default component.exports